import { useLocation } from 'react-router-dom';
import { CanaryBannerContainer } from 'src/components/canaryDeploymentNotice';
import { NavigateBlockerProviderV2 } from 'src/components/navigateBlockerProvider';

import { LayoutProps } from './Layout.interface';
import {
  OwnerOperatorContent,
  OwnerOperatorContentInner,
} from './Layout.styled';
import {
  isFullScreenPath,
  isTopBarHiddenPath,
} from './OwnerOperatorLayout.helper';
import { Sidebar } from './sidebar/Sidebar';
import { TopBar } from './topbar/TopBar';

export const OwnerOperatorLayout: React.FC<LayoutProps> = (props) => {
  const location = useLocation();
  const isFullScreen = isFullScreenPath(location.pathname);
  const showTopBar = !isTopBarHiddenPath(location.pathname);

  return (
    <>
      {!isFullScreen && <Sidebar />}
      {showTopBar && <TopBar />}
      <OwnerOperatorContent $withTopBar={showTopBar} $fullScreen={isFullScreen}>
        <CanaryBannerContainer />
        <OwnerOperatorContentInner $fullScreen={isFullScreen}>
          <NavigateBlockerProviderV2>
            {props.children}
          </NavigateBlockerProviderV2>
        </OwnerOperatorContentInner>
      </OwnerOperatorContent>
    </>
  );
};
